import React, { type FC, useCallback, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ToastContext, type ToastMessage} from './ToastContext';

let nextToastId = 0;

type SnackbarToastProps = {
    children: React.ReactNode;
};

const SnackbarToast: FC<SnackbarToastProps> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    const addToast = useCallback((message: ToastMessage): number => {
        const id = ++nextToastId;
        setToasts((prevToasts) => [...prevToasts, { ...message, id }]);
        return id;
    }, []);

    const removeToast = useCallback((id: number) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    const handleCloseSnackbar = useCallback((id: number) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ addToast, removeToast }}>
            {children}
            {toasts.map((toast, index) => (
                <Snackbar anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                          key={toast.id}
                          open autoHideDuration={toast.duration ?? 5000}
                          onClose={() => handleCloseSnackbar(toast.id as number)}
                          style={{ bottom: `${(index + 1) * 60}px` }}>
                    <Alert onClose={() => handleCloseSnackbar(toast.id as number)} severity={toast.type} style={{ width: '100%' }}>
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </ToastContext.Provider>
    );
};

export default SnackbarToast;
